import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import moment from 'moment';
import { BILLING_PRODUCT } from '../constants';

const TransactionRow = ({ transaction }) => (
  <div className="transactions-table__row" key={transaction.get('id')}>
    <div className="transactions-table__cell transactions-table__date">
      {moment.unix(transaction.get('created')).format('YYYY-MM-DD')}
    </div>
    <div className="transactions-table__cell transactions-table__items">
      {BILLING_PRODUCT}
    </div>
    <div className="transactions-table__cell transactions-table__charge">
      {transaction.get('amount_due') / 100}$
    </div>
    <div className="transactions-table__cell transactions-table__invoice">
      <a
        className={'transactions__invoice'}
        href={transaction.get('hostedInvoiceUrl')}
        target={'_blank'}
      >
        {transaction.get('number')}
      </a>
    </div>
  </div>
);

TransactionRow.propTypes = {
  transaction: PropTypes.instanceOf(Immutable.Map),
};

export default TransactionRow;



// WEBPACK FOOTER //
// ./app/components/reps/settings/transactions/_TransactionRowDesktop.jsx